!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("singleline"), require("lodash.isequal"), require("fbjs/lib/emptyFunction"), require("fbjs/lib/invariant"), require("react-dom")) : "function" == typeof define && define.amd ? define(["react", "singleline", "lodash.isequal", "fbjs/lib/emptyFunction", "fbjs/lib/invariant", "react-dom"], t) : "object" == typeof exports ? exports.ReactResponsiveSelect = t(require("react"), require("singleline"), require("lodash.isequal"), require("fbjs/lib/emptyFunction"), require("fbjs/lib/invariant"), require("react-dom")) : e.ReactResponsiveSelect = t(e.react, e.singleline, e["lodash.isequal"], e["fbjs/lib/emptyFunction"], e["fbjs/lib/invariant"], e["react-dom"]);
}(this, function (e, t, n, r, l, i) {
  return function (e) {
    function t(r) {
      if (n[r]) return n[r].exports;
      var l = n[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(l.exports, l, l.exports, t), l.l = !0, l.exports;
    }
    var n = {};
    return t.m = e, t.c = n, t.d = function (e, n, r) {
      t.o(e, n) || Object.defineProperty(e, n, {
        configurable: !1,
        enumerable: !0,
        get: r
      });
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(n, "a", n), n;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "", t(t.s = 8);
  }([function (e, t) {
    e.exports = require("react");
  }, function (e, t) {
    e.exports = require("singleline");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(9);
    Object.defineProperty(t, "ReactResponsiveSelectProps", {
      enumerable: !0,
      get: function get() {
        return r.ReactResponsiveSelectProps;
      }
    });
    var l = n(14);
    Object.defineProperty(t, "MultiSelectProps", {
      enumerable: !0,
      get: function get() {
        return l.MultiSelectProps;
      }
    });
    var i = n(15);
    Object.defineProperty(t, "MultiSelectOptionProps", {
      enumerable: !0,
      get: function get() {
        return i.MultiSelectOptionProps;
      }
    });
    var o = n(16);
    Object.defineProperty(t, "SingleSelectProps", {
      enumerable: !0,
      get: function get() {
        return o.SingleSelectProps;
      }
    });
    var a = n(17);
    Object.defineProperty(t, "SingleSelectOptionProps", {
      enumerable: !0,
      get: function get() {
        return a.SingleSelectOptionProps;
      }
    });
  }, function (e, t, n) {
    e.exports = n(10)();
  }, function (e, t) {
    e.exports = require("lodash.isequal");
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    t.INITIALISE = "INITIALISE", t.UPDATE_VIA_PROPS = "UPDATE_VIA_PROPS", t.SET_IS_DRAGGING = "SET_IS_DRAGGING", t.SET_OPTIONS_PANEL_OPEN = "SET_OPTIONS_PANEL_OPEN", t.SET_OPTIONS_PANEL_CLOSED = "SET_OPTIONS_PANEL_CLOSED", t.SET_SINGLESELECT_OPTIONS = "SET_SINGLESELECT_OPTIONS", t.SET_MULTISELECT_OPTIONS = "SET_MULTISELECT_OPTIONS", t.SET_OPTIONS_PANEL_CLOSED_NO_SELECTION = "SET_OPTIONS_PANEL_CLOSED_NO_SELECTION", t.SET_OPTIONS_PANEL_CLOSED_ONBLUR = "SET_OPTIONS_PANEL_CLOSED_ONBLUR", t.SET_NEXT_SELECTED_INDEX = "SET_NEXT_SELECTED_INDEX", t.SET_NEXT_SELECTED_INDEX_ALPHA_NUMERIC = "SET_NEXT_SELECTED_INDEX_ALPHA_NUMERIC";
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function l(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }
    function o(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }
        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      }(),
      u = function e(t, n, r) {
        null === t && (t = Function.prototype);
        var l = Object.getOwnPropertyDescriptor(t, n);
        if (void 0 === l) {
          var i = Object.getPrototypeOf(t);
          return null === i ? void 0 : e(i, n, r);
        }
        if ("value" in l) return l.value;
        var o = l.get;
        if (void 0 !== o) return o.call(r);
      },
      s = n(31),
      c = r(s),
      d = n(7),
      f = r(d),
      p = function p(e) {
        return function (e) {
          function t() {
            return l(this, t), i(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
          }
          return o(t, e), a(t, [{
            key: "scrollIntoView",
            value: function value() {
              var e = this.props,
                t = e.scrollIntoViewElementSelector,
                n = e.scrollIntoViewScrollPaneRef,
                r = e.isDragging;
              this.scrollPaneDOM = this.scrollPaneDOM || n(), this.elementDOM = this.elementDOM || c.default.findDOMNode(this);
              var l = (0, f.default)(this.elementDOM, t);
              if (!0 === r && (this.dontScrollIntoView = !0), !this.dontScrollIntoView && l) {
                var i = this.scrollPaneDOM.getBoundingClientRect().top,
                  o = this.scrollPaneDOM.getBoundingClientRect().bottom,
                  a = this.elementDOM.getBoundingClientRect().top;
                this.elementDOM.getBoundingClientRect().bottom > o && (this.scrollPaneDOM.scrollTop += this.elementDOM.getBoundingClientRect().height), a < i && (this.scrollPaneDOM.scrollTop -= this.elementDOM.getBoundingClientRect().height), "0" === this.elementDOM.getAttribute("data-key") && (this.scrollPaneDOM.scrollTop = 0);
              }
            }
          }, {
            key: "componentDidUpdate",
            value: function value() {
              return u(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "componentDidUpdate", this) && u(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "componentDidUpdate", this).call(this), this.scrollIntoView();
            }
          }, {
            key: "render",
            value: function value() {
              return u(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "render", this).call(this);
            }
          }]), t;
        }(e);
      };
    t.default = p;
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      return String(e.className).split(" ").indexOf(t) > -1;
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = r;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function l(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }
    function o(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
      },
      u = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }
        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      }(),
      s = n(0),
      c = r(s),
      d = n(1),
      f = r(d),
      p = n(4),
      S = r(p),
      _ = n(2),
      O = n(5),
      b = function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
        return t.default = e, t;
      }(O),
      h = n(18),
      m = r(h),
      y = n(19),
      v = r(y),
      P = n(29),
      E = r(P),
      g = n(32),
      I = r(g),
      x = n(7),
      T = r(x),
      N = n(34),
      j = r(N),
      M = n(35),
      D = r(M),
      L = n(36),
      C = function (e) {
        function t() {
          var e, n, r, o;
          l(this, t);
          for (var a = arguments.length, u = Array(a), s = 0; s < a; s++) u[s] = arguments[s];
          return n = r = i(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(u))), r.state = y.initialState, r.reducer = v.default, r.listeners = {}, r.handleBlur = r.handleBlur.bind(r), r.handleTouchMove = r.handleTouchMove.bind(r), r.handleTouchStart = r.handleTouchStart.bind(r), r.handleClick = r.handleClick.bind(r), r.handleKeyEvent = r.handleKeyEvent.bind(r), o = n, i(r, o);
        }
        return o(t, e), u(t, [{
          key: "componentDidMount",
          value: function value() {
            var e = this.props,
              t = e.options,
              n = e.selectedValue,
              r = e.selectedValues,
              l = e.name,
              i = e.multiselect,
              o = e.disabled,
              a = e.altered;
            this.updateState({
              type: b.INITIALISE,
              value: {
                options: t,
                selectedValue: n,
                selectedValues: r,
                name: l,
                multiselect: i,
                disabled: o,
                altered: a
              }
            }), this.listeners = {
              onTouchStart: this.handleTouchStart,
              onTouchMove: this.handleTouchMove,
              onTouchEnd: this.handleClick,
              onBlur: this.handleBlur,
              onMouseDown: this.handleClick,
              onKeyDown: this.handleKeyEvent
            };
          }
        }, {
          key: "componentWillReceiveProps",
          value: function value(e) {
            (0, S.default)(e, this.props) || this.updateState({
              type: b.UPDATE_VIA_PROPS,
              value: a({}, this.props, e)
            });
          }
        }, {
          key: "componentDidUpdate",
          value: function value(e, t) {
            var n = this.state,
              r = n.singleSelectSelectedOption,
              l = n.multiSelectSelectedOptions,
              i = n.isMultiSelect,
              o = n.altered,
              a = this.props.onChange;
            if (this.props.selectedValue === this.state.singleSelectInitialIndex || (0, S.default)(this.props.selectedValues, this.state.multiSelectInitialSelectedIndexes)) return !1;
            i ? (0, L.multiSelectBroadcastChange)(t.multiSelectSelectedOptions.options, l.options, o, a) : (0, L.singleSelectBroadcastChange)(t.singleSelectSelectedOption, r, o, a);
          }
        }, {
          key: "render",
          value: function value() {
            var e = this,
              t = this.props,
              n = t.prefix,
              r = t.caretIcon,
              l = t.customLabelRenderer,
              i = t.disabled,
              o = this.state,
              u = o.altered,
              s = o.singleSelectInitialIndex,
              d = o.isOptionsPanelOpen,
              p = o.isDragging,
              S = o.multiSelectInitialSelectedIndexes,
              _ = o.multiSelectSelectedIndexes,
              O = o.multiSelectSelectedOptions,
              b = o.name,
              h = o.nextPotentialSelectionIndex,
              m = o.options,
              y = o.singleSelectSelectedIndex,
              v = o.singleSelectSelectedOption;
            if (o.isMultiSelect) {
              var P = l && l(O) || !1;
              return c.default.createElement("div", a({
                className: (0, f.default)("\n            rrs\n            " + (!0 === d ? "rrs--options-visible" : "") + "\n            " + (u ? "rrs--has-changed" : "") + "\n          "),
                ref: function ref(t) {
                  e.selectBox = t;
                }
              }, this.listeners), c.default.createElement(I.default, {
                disabled: i,
                altered: u,
                isDragging: p,
                caretIcon: r,
                customLabelText: P,
                prefix: n,
                name: b,
                multiSelectInitialSelectedIndexes: S,
                multiSelectSelectedOptions: O,
                multiSelectSelectedIndexes: _,
                nextPotentialSelectionIndex: h,
                isOptionsPanelOpen: d,
                options: m
              }));
            }
            var g = l && l(v) || !1;
            return c.default.createElement("div", a({
              className: (0, f.default)("\n            rrs\n            " + (!0 === d ? "rrs--options-visible" : "") + "\n            " + (u ? "rrs--has-changed" : "") + "\n          "),
              ref: function ref(t) {
                e.selectBox = t;
              }
            }, this.listeners), c.default.createElement(E.default, {
              disabled: i,
              altered: u,
              isDragging: p,
              singleSelectInitialIndex: s,
              caretIcon: r,
              prefix: n,
              name: b,
              customLabelText: g,
              singleSelectSelectedOption: v,
              singleSelectSelectedIndex: y,
              nextPotentialSelectionIndex: h,
              isOptionsPanelOpen: d,
              options: m
            }));
          }
        }, {
          key: "updateState",
          value: function value(e, t) {
            var n = this.reducer(this.state, e);
            this.setState(n, function () {
              return t && t();
            }), (0, j.default)(this.props.name, e, n);
          }
        }, {
          key: "handleTouchStart",
          value: function value() {
            this.state.disabled || this.updateState({
              type: b.SET_IS_DRAGGING,
              boolean: !1
            });
          }
        }, {
          key: "handleTouchMove",
          value: function value() {
            var e = this.state,
              t = e.isDragging;
            e.disabled || t || this.updateState({
              type: b.SET_IS_DRAGGING,
              boolean: !0
            });
          }
        }, {
          key: "handleKeyEvent",
          value: function value(e) {
            var t = this,
              n = this.state,
              r = n.isMultiSelect,
              l = n.isOptionsPanelOpen;
            if (!n.disabled) {
              switch (this.preventDefaultForKeyCodes([m.default.ENTER, m.default.SPACE, m.default.ESCAPE, m.default.UP, m.default.DOWN], e), e.keyCode) {
                case m.default.TAB:
                  return l && (e.preventDefault(), r && this.updateState({
                    type: b.SET_OPTIONS_PANEL_CLOSED
                  }, function () {
                    return t.focusButton;
                  })), e;
                case m.default.ENTER:
                  return this.handleEnterPressed(e);
                case m.default.SPACE:
                  return l ? this.handleClick(e) : this.updateState({
                    type: b.SET_OPTIONS_PANEL_OPEN
                  });
                case m.default.ESCAPE:
                  return this.updateState({
                    type: b.SET_OPTIONS_PANEL_CLOSED_NO_SELECTION
                  }, function () {
                    return t.focusButton;
                  });
                case m.default.UP:
                  return this.handleKeyUpOrDownPressed("decrement");
                case m.default.DOWN:
                  return this.handleKeyUpOrDownPressed("increment");
              }
              /^[a-z0-9]+$/.test(e.key) && this.handleAlphaNumerical(e);
            }
          }
        }, {
          key: "handleClick",
          value: function value(e) {
            var t = this,
              n = this.state,
              r = n.isMultiSelect,
              l = n.isOptionsPanelOpen,
              i = n.isDragging;
            if (!n.disabled && !1 === i) {
              if (e.preventDefault(), e && (0, T.default)(e.target, "rrs__options")) return !0;
              if ((0, T.default)(e.target, "rrs__option")) return this.updateState({
                type: r ? b.SET_MULTISELECT_OPTIONS : b.SET_SINGLESELECT_OPTIONS,
                optionIndex: parseFloat(e.target.getAttribute("data-key"))
              });
              this.updateState({
                type: l ? b.SET_OPTIONS_PANEL_CLOSED : b.SET_OPTIONS_PANEL_OPEN
              }, function () {
                return t.focusButton;
              });
            }
          }
        }, {
          key: "handleBlur",
          value: function value() {
            var e = this.state,
              t = e.isOptionsPanelOpen;
            if (!e.disabled) return this.selectBox && !this.selectBox.contains(document.activeElement) && t ? this.updateState({
              type: b.SET_OPTIONS_PANEL_CLOSED_ONBLUR
            }) : void 0;
          }
        }, {
          key: "handleAlphaNumerical",
          value: function value(e) {
            var t = this.state,
              n = t.options;
            if (!t.disabled) {
              var r = n.map(function (e) {
                return e.text.toLowerCase().charAt(0);
              }).indexOf(e.key);
              r > -1 && this.updateState({
                type: b.SET_NEXT_SELECTED_INDEX_ALPHA_NUMERIC,
                optionIndex: r
              });
            }
          }
        }, {
          key: "handleEnterPressed",
          value: function value(e) {
            var t = this.state,
              n = t.isMultiSelect,
              r = t.isOptionsPanelOpen,
              l = t.nextPotentialSelectionIndex;
            if (!t.disabled) return n ? this.updateState({
              type: b.SET_MULTISELECT_OPTIONS,
              optionIndex: l
            }) : this.updateState({
              type: b.SET_SINGLESELECT_OPTIONS,
              optionIndex: l
            }), r ? e.stopPropagation() : this.props.onSubmit();
          }
        }, {
          key: "handleKeyUpOrDownPressed",
          value: function value(e) {
            var t = this.state,
              n = t.isOptionsPanelOpen,
              r = t.nextPotentialSelectionIndex,
              l = t.options;
            t.disabled || (this.updateState({
              type: b.SET_NEXT_SELECTED_INDEX,
              optionIndex: (0, D.default)(e, n, r, l.length)
            }), !1 === n && this.updateState({
              type: b.SET_OPTIONS_PANEL_OPEN
            }));
          }
        }, {
          key: "preventDefaultForKeyCodes",
          value: function value(e, t) {
            e.forEach(function (e) {
              e === t.keyCode && t.preventDefault();
            });
          }
        }, {
          key: "focusButton",
          value: function value() {
            this.selectBox.querySelector(".rrs__button").focus();
          }
        }]), t;
      }(s.Component);
    t.default = C, C.propTypes = _.ReactResponsiveSelectProps;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ReactResponsiveSelectProps = void 0;
    var r = n(3),
      l = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(r);
    t.ReactResponsiveSelectProps = {
      caretIcon: l.default.oneOfType([l.default.string, l.default.element]),
      customLabelRenderer: l.default.func,
      disabled: l.default.bool,
      multiselect: l.default.bool,
      name: l.default.string.isRequired,
      onChange: l.default.func,
      options: l.default.arrayOf(l.default.shape({
        text: l.default.string.isRequired,
        value: l.default.string.isRequired
      })).isRequired,
      onSubmit: l.default.func,
      prefix: l.default.string,
      selectedValue: l.default.string,
      selectedValues: l.default.arrayOf(l.default.string.isRequired)
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(11),
      l = n(12),
      i = n(13);
    e.exports = function () {
      function e(e, t, n, r, o, a) {
        a !== i && l(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      }
      function t() {
        return e;
      }
      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t
      };
      return n.checkPropTypes = r, n.PropTypes = n, n;
    };
  }, function (e, t) {
    e.exports = require("fbjs/lib/emptyFunction");
  }, function (e, t) {
    e.exports = require("fbjs/lib/invariant");
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MultiSelectProps = void 0;
    var r = n(3),
      l = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(r);
    t.MultiSelectProps = {
      altered: l.default.bool,
      caretIcon: l.default.oneOfType([l.default.string, l.default.element]),
      customLabelText: l.default.oneOfType([l.default.string, l.default.bool, l.default.element]),
      disabled: l.default.bool,
      multiSelectInitialSelectedIndexes: l.default.arrayOf(l.default.number),
      multiSelectSelectedIndexes: l.default.arrayOf(l.default.number),
      multiSelectSelectedOptions: l.default.shape({
        altered: l.default.bool,
        options: l.default.arrayOf(l.default.shape({
          name: l.default.string,
          text: l.default.string,
          value: l.default.string,
          markup: l.default.object
        }))
      }),
      isDragging: l.default.bool,
      isOptionsPanelOpen: l.default.bool,
      name: l.default.string,
      nextPotentialSelectionIndex: l.default.number,
      onSubmit: l.default.func,
      options: l.default.arrayOf(l.default.shape({
        text: l.default.string.isRequired,
        value: l.default.string.isRequired
      })).isRequired,
      prefix: l.default.string
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.MultiSelectOptionProps = void 0;
    var r = n(3),
      l = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(r);
    t.MultiSelectOptionProps = {
      index: l.default.number.isRequired,
      isOptionsPanelOpen: l.default.bool.isRequired,
      multiSelectSelectedIndexes: l.default.arrayOf(l.default.number),
      nextPotentialSelectionIndex: l.default.number,
      option: l.default.shape({
        text: l.default.string.isRequired,
        value: l.default.string.isRequired,
        markup: l.default.element
      }).isRequired
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SingleSelectProps = void 0;
    var r = n(3),
      l = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(r);
    t.SingleSelectProps = {
      altered: l.default.bool,
      caretIcon: l.default.oneOfType([l.default.string, l.default.element]),
      customLabelText: l.default.oneOfType([l.default.string, l.default.bool, l.default.element]),
      disabled: l.default.bool,
      singleSelectInitialIndex: l.default.number,
      singleSelectSelectedIndex: l.default.number,
      singleSelectSelectedOption: l.default.shape({
        text: l.default.string,
        value: l.default.string
      }),
      isDragging: l.default.bool,
      isOptionsPanelOpen: l.default.bool,
      name: l.default.string,
      nextPotentialSelectionIndex: l.default.number,
      onSubmit: l.default.func,
      options: l.default.arrayOf(l.default.shape({
        text: l.default.string.isRequired,
        value: l.default.string.isRequired
      })).isRequired,
      prefix: l.default.string,
      selectedValue: l.default.string
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SingleSelectOptionProps = void 0;
    var r = n(3),
      l = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(r);
    t.SingleSelectOptionProps = {
      index: l.default.number.isRequired,
      isOptionsPanelOpen: l.default.bool.isRequired,
      nextPotentialSelectionIndex: l.default.number,
      option: l.default.shape({
        text: l.default.string.isRequired,
        value: l.default.string.isRequired,
        markup: l.default.element
      }).isRequired,
      singleSelectSelectedIndex: l.default.number
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = {
      TAB: 9,
      ENTER: 13,
      SPACE: 32,
      ESCAPE: 27,
      UP: 38,
      DOWN: 40
    };
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function l(e) {
      if (Array.isArray(e)) {
        for (var t = 0, n = Array(e.length); t < e.length; t++) n[t] = e[t];
        return n;
      }
      return Array.from(e);
    }
    function i(e) {
      return a({}, e, {
        multiSelectSelectedIndexes: [].concat(l(N.multiSelectSelectedIndexes)),
        multiSelectSelectedOptions: a({}, N.multiSelectSelectedOptions)
      });
    }
    function o(e, t) {
      switch (t.type) {
        case s.UPDATE_VIA_PROPS:
        case s.INITIALISE:
          var n = (0, d.default)(t.value.options, t.value.selectedValue),
            r = (0, p.default)(t.value.options, t.value.selectedValues),
            l = (0, _.default)(t.value.options, t.value.selectedValues, t.value.name);
          return a({}, e, {
            isMultiSelect: t.value.multiselect || !1,
            name: t.value.name,
            options: t.value.options,
            altered: t.value.altered || !1,
            disabled: t.value.disabled || !1,
            singleSelectInitialIndex: n,
            singleSelectSelectedIndex: n,
            singleSelectSelectedOption: a({
              name: t.value.name
            }, t.value.options[n]),
            nextPotentialSelectionIndex: n,
            multiSelectInitialSelectedIndexes: r,
            multiSelectSelectedIndexes: r,
            multiSelectSelectedOptions: {
              options: l
            }
          });
        case s.SET_IS_DRAGGING:
          return a({}, e, {
            isDragging: t.boolean
          });
        case s.SET_OPTIONS_PANEL_OPEN:
          var o = a({}, e, {
            isOptionsPanelOpen: !0,
            nextPotentialSelectionIndex: e.singleSelectSelectedIndex,
            singleSelectSelectedOption: a({
              name: e.name
            }, e.options[e.singleSelectSelectedIndex])
          });
          return (0, I.default)(o);
        case s.SET_OPTIONS_PANEL_CLOSED:
          var u = a({}, e, {
            isOptionsPanelOpen: !1,
            singleSelectSelectedIndex: e.nextPotentialSelectionIndex,
            singleSelectSelectedOption: a({
              name: e.name
            }, e.options[e.nextPotentialSelectionIndex])
          });
          return (0, I.default)(u);
        case s.SET_OPTIONS_PANEL_CLOSED_NO_SELECTION:
        case s.SET_OPTIONS_PANEL_CLOSED_ONBLUR:
          return a({}, e, {
            isOptionsPanelOpen: !1
          });
        case s.SET_NEXT_SELECTED_INDEX:
          return a({}, e, {
            nextPotentialSelectionIndex: t.optionIndex
          });
        case s.SET_NEXT_SELECTED_INDEX_ALPHA_NUMERIC:
          return a({}, e, {
            isOptionsPanelOpen: !0,
            nextPotentialSelectionIndex: t.optionIndex
          });
        case s.SET_SINGLESELECT_OPTIONS:
          var c = a({}, e, {
            nextPotentialSelectionIndex: t.optionIndex,
            singleSelectSelectedIndex: t.optionIndex,
            isOptionsPanelOpen: !1,
            singleSelectSelectedOption: a({
              name: e.name
            }, e.options[t.optionIndex])
          });
          return (0, I.default)(c);
        case s.SET_MULTISELECT_OPTIONS:
          var f = 0 === e.multiSelectSelectedIndexes[0] && 1 === e.multiSelectSelectedIndexes.length,
            S = e.multiSelectSelectedIndexes.length > 0 && !f && 0 === t.optionIndex,
            O = f && 0 !== t.optionIndex;
          if (S) {
            var h = (0, T.default)(e);
            return (0, I.default)(h);
          }
          O && (e = i(e));
          var y = e.multiSelectSelectedIndexes.indexOf(t.optionIndex),
            P = a({}, e, {
              nextPotentialSelectionIndex: t.optionIndex,
              multiSelectSelectedIndexes: -1 === y ? (0, b.default)(e, t.optionIndex) : (0, m.default)(e, y),
              multiSelectSelectedOptions: -1 === y ? (0, v.default)(e, t.optionIndex) : (0, E.default)(e, y)
            });
          return 0 === P.multiSelectSelectedOptions.options.length && (P = (0, T.default)(e)), (0, I.default)(P);
      }
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.initialState = void 0;
    var a = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];
        for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
      return e;
    };
    t.default = o;
    var u = n(5),
      s = function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
        return t.default = e, t;
      }(u),
      c = n(20),
      d = r(c),
      f = n(21),
      p = r(f),
      S = n(22),
      _ = r(S),
      O = n(23),
      b = r(O),
      h = n(24),
      m = r(h),
      y = n(25),
      v = r(y),
      P = n(26),
      E = r(P),
      g = n(27),
      I = r(g),
      x = n(28),
      T = r(x),
      N = t.initialState = {
        isMultiSelect: !1,
        name: void 0,
        options: [],
        isDragging: !1,
        isOptionsPanelOpen: !1,
        altered: !1,
        singleSelectInitialIndex: 0,
        singleSelectSelectedIndex: 0,
        singleSelectSelectedOption: {},
        nextPotentialSelectionIndex: 0,
        multiSelectInitialSelectedIndexes: [0],
        multiSelectSelectedOptions: {
          options: []
        },
        multiSelectSelectedIndexes: []
      };
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      var n = e.map(function (e) {
        return e.value;
      }).indexOf(t);
      return n > -1 ? n : 0;
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = r;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
        n = e.map(function (e, n) {
          return t.some(function (t) {
            return e.value === t;
          }) ? n : void 0;
        }).filter(function (e) {
          return void 0 !== e;
        });
      return n.length ? n : [0];
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = r;
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {
      return t ? e.filter(function (e) {
        return t.some(function (t) {
          return t === e.value;
        });
      }).map(function (e) {
        return l({
          name: n
        }, e);
      }) : [l({
        name: n
      }, e[0])];
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var l = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];
        for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
      return e;
    };
    t.default = r;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      if (Array.isArray(e)) {
        for (var t = 0, n = Array(e.length); t < e.length; t++) n[t] = e[t];
        return n;
      }
      return Array.from(e);
    }
    function l(e, t) {
      return [].concat(r(e.multiSelectSelectedIndexes), [t]);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = l;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      if (Array.isArray(e)) {
        for (var t = 0, n = Array(e.length); t < e.length; t++) n[t] = e[t];
        return n;
      }
      return Array.from(e);
    }
    function l(e, t) {
      return [].concat(r(e.multiSelectSelectedIndexes.slice(0, t)), r(e.multiSelectSelectedIndexes.slice(t + 1)));
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = l;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      if (Array.isArray(e)) {
        for (var t = 0, n = Array(e.length); t < e.length; t++) n[t] = e[t];
        return n;
      }
      return Array.from(e);
    }
    function l(e, t) {
      return {
        options: [].concat(r(e.multiSelectSelectedOptions.options), [i({
          name: e.name
        }, e.options[t])])
      };
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];
        for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
      return e;
    };
    t.default = l;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      if (Array.isArray(e)) {
        for (var t = 0, n = Array(e.length); t < e.length; t++) n[t] = e[t];
        return n;
      }
      return Array.from(e);
    }
    function l(e, t) {
      return {
        options: [].concat(r(e.multiSelectSelectedOptions.options.slice(0, t)), r(e.multiSelectSelectedOptions.options.slice(t + 1)))
      };
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = l;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e.isMultiSelect ? !(0, a.default)(e.multiSelectInitialSelectedIndexes, e.multiSelectSelectedIndexes) : e.singleSelectSelectedIndex !== e.singleSelectInitialIndex;
    }
    function l(e) {
      return i({}, e, {
        altered: r(e)
      });
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];
        for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
      return e;
    };
    t.isAltered = r, t.default = l;
    var o = n(4),
      a = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(o);
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return l({}, e, {
        multiSelectSelectedIndexes: [0],
        multiSelectSelectedOptions: {
          options: [l({
            name: e.name
          }, e.options[0])]
        },
        nextPotentialSelectionIndex: 0
      });
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var l = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];
        for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
      return e;
    };
    t.default = r;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function l(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }
    function o(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }
        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      }(),
      u = n(0),
      s = r(u),
      c = n(2),
      d = n(1),
      f = r(d),
      p = n(30),
      S = r(p),
      _ = n(6),
      O = r(_),
      b = (0, O.default)(S.default),
      h = function (e) {
        function t() {
          return l(this, t), i(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
        }
        return o(t, e), a(t, [{
          key: "componentDidUpdate",
          value: function value(e) {
            !this.props.isOptionsPanelOpen && e.isOptionsPanelOpen && e.singleSelectSelectedIndex !== this.props.singleSelectSelectedIndex && this.optionsButton.focus();
          }
        }, {
          key: "render",
          value: function value() {
            var e = this,
              t = this.props,
              n = t.caretIcon,
              r = t.customLabelText,
              l = t.disabled,
              i = t.isOptionsPanelOpen,
              o = t.isDragging,
              a = t.name,
              u = t.nextPotentialSelectionIndex,
              c = t.options,
              d = t.prefix,
              p = t.singleSelectSelectedIndex,
              S = t.singleSelectSelectedOption;
            return s.default.createElement("div", null, s.default.createElement("div", {
              role: "button",
              tabIndex: "0",
              "aria-disabled": l,
              "aria-haspopup": "true",
              "aria-expanded": "" + i,
              "aria-controls": "rrs-" + a + "-menu",
              ref: function ref(t) {
                if (t) return e.optionsButton = t;
              },
              className: (0, f.default)("\n            rrs__button\n            " + (!0 === l ? "rrs__button--disabled" : "") + "\n          ")
            }, r && s.default.createElement("div", {
              className: "rrs__label"
            }, s.default.createElement("span", {
              "aria-label": (d ? d + " " : "") + S.text + " selected",
              className: "rrs__label__text",
              id: "rrs-" + a + "-label"
            }, r), n && n), !r && s.default.createElement("div", {
              className: "rrs__label"
            }, s.default.createElement("span", {
              "aria-label": (d ? d + " " : "") + S.text + " selected",
              className: "rrs__label__text",
              id: "rrs-" + a + "-label"
            }, d && s.default.createElement("span", null, d), S.text), n && n), a && s.default.createElement("input", {
              type: "hidden",
              name: a,
              value: S.value
            })), s.default.createElement("ul", {
              id: "rrs-" + a + "-menu",
              "aria-labelledby": "rrs-" + a + "-label",
              role: "menu",
              className: "rrs__options",
              ref: function ref(t) {
                if (t) return e.optionsContainer = t;
              }
            }, c.length > 0 && c.map(function (t, n) {
              return s.default.createElement(b, {
                scrollIntoViewScrollPaneRef: function scrollIntoViewScrollPaneRef() {
                  return e.optionsContainer;
                },
                scrollIntoViewElementSelector: "rrs__option--next-selection",
                key: n,
                index: n,
                isDragging: o,
                isOptionsPanelOpen: i,
                option: t,
                singleSelectSelectedIndex: p,
                nextPotentialSelectionIndex: u
              });
            })));
          }
        }]), t;
      }(u.Component);
    t.default = h, h.propTypes = c.SingleSelectProps;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function l(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }
    function o(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }
        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      }(),
      u = n(0),
      s = r(u),
      c = n(2),
      d = n(1),
      f = r(d),
      p = function (e) {
        function t() {
          return l(this, t), i(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
        }
        return o(t, e), a(t, [{
          key: "componentDidUpdate",
          value: function value() {
            var e = this.props,
              t = e.index,
              n = e.isOptionsPanelOpen;
            t === e.nextPotentialSelectionIndex && n && this["option_" + t].focus();
          }
        }, {
          key: "render",
          value: function value() {
            var e = this,
              t = this.props,
              n = t.index,
              r = t.nextPotentialSelectionIndex,
              l = t.option,
              i = t.singleSelectSelectedIndex;
            return s.default.createElement("li", {
              role: "menuitem",
              tabIndex: "-1",
              "data-key": n,
              ref: function ref(t) {
                e["option_" + n] = t;
              },
              className: (0, f.default)("\n          rrs__option\n          " + (i === n ? "rrs__option--selected" : "") + "\n          " + (r === n ? "rrs__option--next-selection" : "") + "\n        ")
            }, l.markup || l.text);
          }
        }]), t;
      }(u.Component);
    t.default = p, p.propTypes = c.SingleSelectOptionProps;
  }, function (e, t) {
    e.exports = require("react-dom");
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function l(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }
    function o(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }
        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      }(),
      u = n(0),
      s = r(u),
      c = n(2),
      d = n(1),
      f = r(d),
      p = n(4),
      S = r(p),
      _ = n(33),
      O = r(_),
      b = n(6),
      h = r(b),
      m = (0, h.default)(O.default),
      y = function (e) {
        function t() {
          return l(this, t), i(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
        }
        return o(t, e), a(t, [{
          key: "getAriaLabel",
          value: function value() {
            var e = this.props,
              t = e.multiSelectSelectedOptions,
              n = e.prefix,
              r = t.options.length;
            return (0, f.default)("\n      Checkbox group " + (n ? n + " " : "") + " has\n      " + r + " item" + (1 === r ? "" : "s") + " selected.\n      Selected option" + (1 === r ? "" : "s") + " " + (1 === r ? "is" : "are") + "\n      " + t.options.map(function (e) {
              return e.text;
            }).join(" and ") + "\n    ");
          }
        }, {
          key: "componentDidUpdate",
          value: function value(e) {
            this.props.isOptionsPanelOpen || !e.isOptionsPanelOpen || (0, S.default)(e.multiSelectSelectedIndexes, this.props.multiSelectSelectedIndexes) || this.optionsButton.focus();
          }
        }, {
          key: "render",
          value: function value() {
            var e = this,
              t = this.props,
              n = t.caretIcon,
              r = t.customLabelText,
              l = t.disabled,
              i = t.isDragging,
              o = t.isOptionsPanelOpen,
              a = t.multiSelectSelectedIndexes,
              u = t.multiSelectSelectedOptions,
              c = t.name,
              d = t.options,
              p = t.nextPotentialSelectionIndex,
              S = t.prefix;
            return s.default.createElement("div", null, s.default.createElement("div", {
              role: "button",
              tabIndex: "0",
              "aria-disabled": l,
              "aria-haspopup": "true",
              "aria-expanded": "" + o,
              "aria-controls": "rrs-" + c + "-menu",
              ref: function ref(t) {
                if (t) return e.optionsButton = t;
              },
              className: (0, f.default)("\n            rrs__button\n            " + (!0 === l ? "rrs__button--disabled" : "") + "\n          ")
            }, r && s.default.createElement("div", {
              className: "rrs__label"
            }, s.default.createElement("span", {
              "aria-label": this.getAriaLabel(),
              className: "rrs__label__text",
              id: "rrs-" + c + "-label"
            }, r), n && n), !r && s.default.createElement("div", {
              className: "rrs__label"
            }, s.default.createElement("span", {
              "aria-label": this.getAriaLabel(),
              className: "rrs__label__text",
              id: "rrs-" + c + "-label"
            }, s.default.createElement("span", {
              className: "rrs__multiselect-label"
            }, s.default.createElement("span", {
              className: "rrs__multiselect-label__text"
            }, (S ? S + " " : "") + u.options[0].text), u.options.length > 1 && s.default.createElement("span", {
              className: "rrs__multiselect-label__badge"
            }, "+ " + (u.options.length - 1)))), n && n), c && s.default.createElement("input", {
              type: "hidden",
              name: c,
              value: [u.options.map(function (e) {
                return e.value;
              })].join(",")
            })), s.default.createElement("ul", {
              id: "rrs-" + c + "-menu",
              "aria-labelledby": "rrs-" + c + "-label",
              role: "menu",
              className: "rrs__options",
              ref: function ref(t) {
                if (t) return e.optionsContainer = t;
              }
            }, d.length > 0 && d.map(function (t, n) {
              return s.default.createElement(m, {
                scrollIntoViewScrollPaneRef: function scrollIntoViewScrollPaneRef() {
                  return e.optionsContainer;
                },
                scrollIntoViewElementSelector: "rrs__option--next-selection",
                key: n,
                index: n,
                option: t,
                isDragging: i,
                isOptionsPanelOpen: o,
                multiSelectSelectedIndexes: a,
                nextPotentialSelectionIndex: p
              });
            })));
          }
        }]), t;
      }(u.Component);
    t.default = y, y.propTypes = c.MultiSelectProps;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function l(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }
    function o(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }
        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      }(),
      u = n(0),
      s = r(u),
      c = n(2),
      d = n(1),
      f = r(d),
      p = function (e) {
        function t() {
          return l(this, t), i(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
        }
        return o(t, e), a(t, [{
          key: "componentDidUpdate",
          value: function value() {
            var e = this.props,
              t = e.index,
              n = e.isOptionsPanelOpen;
            t === e.nextPotentialSelectionIndex && n && this["option_" + t].focus();
          }
        }, {
          key: "render",
          value: function value() {
            var e = this,
              t = this.props,
              n = t.index,
              r = t.multiSelectSelectedIndexes,
              l = t.nextPotentialSelectionIndex,
              i = t.option,
              o = r.some(function (e) {
                return e === n;
              });
            return s.default.createElement("li", {
              role: "checkbox",
              tabIndex: "-1",
              "aria-checked": o,
              "aria-label": i.text,
              "aria-live": "assertive",
              "data-key": n,
              ref: function ref(t) {
                e["option_" + n] = t;
              },
              className: (0, f.default)("\n          rrs__option\n          " + (o ? "rrs__option--selected" : "") + "\n          " + (l === n ? "rrs__option--next-selection" : "") + "\n        ")
            }, i.markup || i.text);
          }
        }]), t;
      }(u.Component);
    t.default = p, p.propTypes = c.MultiSelectOptionProps;
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n) {}
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    "function" == typeof Symbol && Symbol.iterator;
    t.default = r;
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n, r) {
      return "increment" === e ? !1 === t ? n : n === r - 1 ? 0 : n + 1 : "decrement" === e ? !1 === t ? n : 0 === n ? r - 1 : n - 1 : void 0;
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = r;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    t.multiSelectBroadcastChange = function (e, t, n, r) {
      if (r) {
        return e.length && (e.length !== t.length || e.map(function (e) {
          return e.value;
        }).join("") !== t.map(function (e) {
          return e.value;
        }).join("")) ? r({
          options: t.map(function (e) {
            return {
              name: e.name,
              text: e.text,
              value: e.value
            };
          }),
          altered: n
        }) : void 0;
      }
    }, t.singleSelectBroadcastChange = function (e, t, n, r) {
      if (r) {
        return e && e.value !== t.value ? r({
          name: t.name,
          text: t.text,
          value: t.value,
          altered: n
        }) : void 0;
      }
    };
  }]);
});